import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row border-primary gx-0" }
const _hoisted_2 = { class: "col-12 border border-primary rounded-3" }
const _hoisted_3 = {
  key: 0,
  class: "p-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase fw-bold text-center py-3" }, " EL SORTEO ESTÁ FINALIZADO ", -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h5 class=\"text-uppercase fw-bold mb-3\"> Estos fueron los ganadores que gracias a Citroën Club pudieron disfrutar del show de JPEGMafia: </h5><ul><li>Facundo Cartolano</li><li>Claudio Angel Tuni</li><li>Marcela Alejandra Cordero</li><li>Leonardo Gabriel Crespo</li><li>Carlos Hernan Tocco</li><li>Rodolfo Frade</li><li>Sebastián Joel Lerner</li><li>Alfrego Augusto Stahlschmidt</li><li>Alberto Gustavo Spinetta</li><li>Norberto Rubén Scandroli</li></ul><h5 class=\"text-uppercase fw-bold mb-3\"> ¡Quedate atento que el próximo podés ser vos! </h5>", 3)
const _hoisted_8 = {
  key: 0,
  class: "p-5"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase fw-bold mb-3" }, " Participá haciendo click en el siguiente botón ", -1)
const _hoisted_10 = {
  key: 0,
  class: "spinner-border text-success",
  role: "status"
}
const _hoisted_11 = {
  key: 1,
  class: "p-5"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", { class: "text-uppercase fw-bold mb-3" }, " Participá haciendo click en el siguiente botón ", -1)
const _hoisted_13 = {
  key: 0,
  class: "spinner-border text-success",
  role: "status"
}
const _hoisted_14 = {
  key: 0,
  class: "spinner-border text-success",
  role: "status"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 2,
  classs: "row"
}
const _hoisted_17 = {
  key: 0,
  class: "col-12 small mt-3 p-3",
  style: {"height":"350px","overflow":"auto"}
}

import { cuponesService } from '@/services/cupones.service'
import { userService } from '@/services/user.service'
import { onMounted, ref } from 'vue'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'
import TheBasesYCondiciones from './bases-condiciones/TheBasesYCondiciones.vue'
import sleep from '@/utils/Sleep'


export default /*#__PURE__*/_defineComponent({
  __name: 'TheSorteo',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: number
};

const { getters } = useStore<VuexStore>(key)



console.log('TheSorteo.vue', props.id);
const loading = ref(false)

const cuponesDisponibles = ref(false)
const cupon = ref()
const url = ref()

const couponRetrieved = ref(false)

const showByC = ref(false)

const termsContainer = ref<HTMLElement | null>(null)
const hasReadTerms = ref(false)

const handleScroll = (event: Event) => {
  const element = event.target as HTMLElement
  const reachedBottom =
    element.scrollHeight - element.scrollTop <= element.clientHeight + 1
  if (reachedBottom) hasReadTerms.value = true
}

const miCupon = async () => {
  const { codigo, store_url } = await userService.misCuponPorActividad(props.id)
  cupon.value = codigo
  url.value = store_url
}

const hayCuponesDisponibles = async () => {
  cuponesDisponibles.value = await cuponesService.hayCuponesDisponibles(
    props.id
  )
}
const obtenerCupon = async () => {
  loading.value = true
  const { codigo, store_url } = await cuponesService.obtenerCupon(props.id)
  await sleep(1) // Simulate loading time
  cupon.value = codigo
  url.value = store_url
  loading.value = false
  couponRetrieved.value = true
}

onMounted(async () => {
  loading.value = true
  if (getters.isLogin) {
    await miCupon()
    if (!cupon.value) {
      await hayCuponesDisponibles()
    }
  }
  loading.value = false
})
const actividadesSinTerminosYCondiciones = [114, 108, 116, 170, 171, 172,173, 174,178]

const actividadesConTerminosYCondiciones = [114, 108, 116]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!cupon.value && !cuponesDisponibles.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            (props.id === 114)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_5
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!cupon.value && cuponesDisponibles.value && !couponRetrieved.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (actividadesSinTerminosYCondiciones.includes(props.id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-primary px-4 py-2 text-uppercase",
                        type: "submit",
                        onClick: obtenerCupon
                      }, " SI, QUIERO PARTICIPAR "))
                ]))
              : (!showByC.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _hoisted_12,
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-primary px-4 py-2 text-uppercase",
                      type: "submit",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showByC.value = !showByC.value))
                    }, " QUIERO PARTICIPAR ")
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", {
                      ref_key: "termsContainer",
                      ref: termsContainer,
                      onScroll: handleScroll,
                      style: {"height":"400px","width":"100%","overflow-y":"auto","padding":"20px","border":"1px solid #ccc"}
                    }, [
                      _createVNode(TheBasesYCondiciones, {
                        id: props.id
                      }, null, 8, ["id"])
                    ], 544),
                    (loading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      style: {"margin-top":"20px"},
                      class: "btn btn-primary px-4 py-2 text-uppercase",
                      type: "submit",
                      onClick: obtenerCupon,
                      disabled: !hasReadTerms.value
                    }, " ACEPTO LOS TÉRMINOS Y CONDICIONES ", 8, _hoisted_15)
                  ], 64))
          ], 64))
        : _createCommentVNode("", true),
      (cupon.value || couponRetrieved.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", {
              class: _normalizeClass(["col-12 fw-bold text-uppercase text-center py-5 h5", { 'border-bottom': actividadesSinTerminosYCondiciones.includes(props.id) }])
            }, [
              ([123,129].includes(props.id))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" YA ESTÁS PARTICIPANDO POR EL SORTEO POR UN LUGAR EN LA EXPERIENCIA ")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("YA ESTAS PARTICIPANDO!")
                  ], 64))
            ], 2),
            (actividadesConTerminosYCondiciones.includes(props.id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(TheBasesYCondiciones, {
                    id: props.id
                  }, null, 8, ["id"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})